


import { GeneralSelectInputs } from "models/Client/GeneralSelectInputs";
import { FC,} from "react";
import { MazakaSelect } from "./MazakaSelect";
import useCapitalize from "./Adress/helpers/useCapitalize";
import { useGetFeedbackCategoryList } from "apps/ProblemsSuggestion/ServerSideStates";


const GeneralFeedbackCategoriesInput: FC<GeneralSelectInputs> = (props) => {
  const categories = useGetFeedbackCategoryList()
  let { capitalize } = useCapitalize();
  return (
    <>
      <MazakaSelect
        name={props.name}
        xs={props.xs}
        sm={props.sm}
        md={props.md}
        lg={props.lg}
        xl={props.xl}
        size={props.size}
        loading={categories.isLoading || categories.isFetching}
        disabled={categories.isLoading || categories.isFetching || props.disabled}
        className={props.className}
        showSearch={true}
        allowClear={props.allowClear || false}
        filterOption={(input, option: any) =>
          (option.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        label={props.label}
        options={
          categories.data?.data
            ? categories.data?.data.map((item: any) => {
                return {
                  key: item.id,
                  value: item.id,
                  label: capitalize(item.name),
                };
              })
            : []
        }
        placeholder={props.placeholder}
        mode={props.mode}
        onChange={props.onChange}
        value={props.value}
        rules={props.rules}
      />
    </>
  );
};

export default GeneralFeedbackCategoriesInput;
